<app-elevation-section [title]="languageService.LNG('Label.Cost')" [removeMargin]="allowEdit" [removePadding]="true">
  <dx-data-grid
    #datagriddx
    class="pointer"
    [dataSource]="filteredExpenses"
    [rowAlternationEnabled]="true"
    [showBorders]="true"
    [columnAutoWidth]="true"
    (onEditorPreparing)="onEditorPreparing($event)"
    (onEditingStart)="onEditingStart($event)"
    (onSaving)="onSavingMultiple($event)"
    (onInitNewRow)="onInitNewRow($event)"
    (onToolbarPreparing)="onToolbarPreparing($event)"
    (onCellPrepared)="onCellPrepared($event)"
    height="{{ allowEdit ? 185 : 140 }}">

    <dxo-editing
      mode="batch"
      [allowUpdating]="allowEdit"
      [allowAdding]="allowEdit"
      [useIcons]="true">
    </dxo-editing>

    <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
    <dxo-scrolling mode="virtual"></dxo-scrolling>
    <dxo-paging [pageSize]="10"></dxo-paging>
    <dxo-selection mode="multiple" showCheckBoxesMode="always"> </dxo-selection>

    <dxi-column *ngIf="!selectedTimeRecord"
      dataField="StatusId"
      caption=" "
      cellTemplate="cellTemplateStatus"
      [allowEditing]="false"
      [width]="15">
    </dxi-column>

    <div *dxTemplate="let cellInfo of 'cellTemplateStatus'"></div>

    <dxi-column
      dataField="ExpenseTypeId"
      [caption]="languageService.LNG('Label.Expense')">

      <dxi-validation-rule type="required"></dxi-validation-rule>

      <dxo-lookup
        [dataSource]="expenseTypes"
        valueExpr="ExpenseTypeId"
        displayExpr="Description">
      </dxo-lookup
    ></dxi-column>

    <dxi-column
      dataField="Value"
      [caption]="languageService.LNG('Label.Value')"
      [width]="50">

      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      dataField="UnitDescription"
      [caption]="languageService.LNG('Label.Unit')"
      [width]="50"
      [allowEditing]="false">
    </dxi-column>

    <dxi-column *ngIf="!selectedTimeRecord"
      dataField="ProjectNumberAndName"
      editCellTemplate="projectEditTemplate"
      [setCellValue]="setProjectValue"
      [caption]="languageService.LNG('Label.Project')"
      [width]="125">

      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <div *dxTemplate="let cellInfo of 'projectEditTemplate'">
      <div *ngIf="timeSalaryTimeComponent">
        <span style="padding-left: 7px" *ngIf="(cellInfo.data.StatusId === 4 && !timeSalaryTimeComponent.allowEditApproved) || (cellInfo.data.StatusId === 3 && !timeSalaryTimeComponent.allowEditConfirmed) || ((cellInfo.data.CategoryId === 1 || cellInfo.data.CategoryId === 7) && cellInfo.data.StatusId === 2 && !timeSalaryTimeComponent.allowEditUnconfirmed); else edit_expense_project_select">{{cellInfo.data.ProjectNumberAndName}}</span>
        <ng-template #edit_expense_project_select>
          <dx-select-box
            [dataSource]="timeSalaryTimeComponent.projectsDataSource"
            displayExpr="ProjectDisplayName"
            searchExpr="ProjectDisplayName"
            valueExpr="ProjectId"
            (onValueChanged)="onProjectValueChanged($event, cellInfo)"
            [searchEnabled]="true"
            [height]="35"
            [showClearButton]="true"
            [placeholder]="timeSalaryTimeComponent.placeholderProjectSelectSearch"
            [value]="cellInfo.data.CarrierId"
            (onFocusIn)="timeSalaryTimeComponent.focusProject($event)">
          </dx-select-box>
        </ng-template>
      </div>
    </div>

    <dxi-column *ngIf="!selectedTimeRecord"
      dataField="EmployeeId"
      editCellTemplate="employeeEditTemplate"
      [caption]="languageService.LNG('Label.Employee')"
      [width]="125">

      <dxi-validation-rule type="required"></dxi-validation-rule>

      <dxo-lookup
        [dataSource]="timeSalaryTimeComponent?.employees"
        valueExpr="EmployeeId"
        displayExpr="EmployeeNumberAndName">
      </dxo-lookup>
    </dxi-column>

    <div *dxTemplate="let cellInfo of 'employeeEditTemplate'">
      <div *ngIf="timeSalaryTimeComponent">
        <span style="padding-left: 7px" *ngIf="(cellInfo.data.StatusId === 4 && !timeSalaryTimeComponent.allowEditApproved) || (cellInfo.data.StatusId === 3 && !timeSalaryTimeComponent.allowEditConfirmed) || ((cellInfo.data.CategoryId === 1 || cellInfo.data.CategoryId === 7) && cellInfo.data.StatusId === 2 && !timeSalaryTimeComponent.allowEditUnconfirmed); else edit_expense_employee_select">{{cellInfo.data.EmployeeNumberAndName}}</span>
        <ng-template #edit_expense_employee_select>
          <dx-select-box
            [dataSource]="{store: timeSalaryTimeComponent.employees, paginate: true, pageSize: 10}"
            displayExpr="EmployeeNumberAndName"
            searchExpr="EmployeeNumberAndName"
            valueExpr="EmployeeId"
            (onValueChanged)="cellInfo.setValue($event.value)"
            [searchEnabled]="true"
            [height]="35"
            [showClearButton]="true"
            [value]="cellInfo.value">
          </dx-select-box>
        </ng-template>
      </div>
    </div>

    <dxi-column *ngIf="!selectedTimeRecord"
      dataField="Date"
      [caption]="languageService.LNG('Label.Date')"
      dataType="date"
      format="dd.MM.yy"
      width="80">

      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      dataField="Comment"
      [caption]="languageService.LNG('Label.Comment')">
    </dxi-column>

  </dx-data-grid>
</app-elevation-section>
